import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-underway',
  templateUrl: './underway.component.html',
  styleUrls: ['./underway.component.css']
})
export class UnderwayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
